import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

export type FindVehicleBrandsEntity = EntityTypeOld<Brand[], OperationType>;

export interface Brand {
  readonly name: string;
  readonly models: string[];
}

export type FindVehicleModelsEntity = EntityTypeOld<Model[], OperationType>;
export interface Model {
  readonly name: string;
  readonly configurations: VehicleModelConfiguration[];
}
export interface VehicleModelConfiguration {
  readonly canBeBoughtOnline: boolean;
  readonly configurationId: number;
  readonly displayName: string;
  readonly driveSmartSupported?: boolean;
  readonly kw: number;
  readonly tfaCode: string;
  readonly volume: number;
}

export type FindVehicleTypeError = ErrorStateOld<OperationType>;

export enum OperationType {
  FIND_BRANDS_BY_YEAR = "FIND_BRANDS_BY_YEAR",
  FIND_MODELS_BY_YEAR_AND_BRAND = "FIND_MODELS_BY_YEAR_AND_BRAND",
}
